// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"ac8d4095","354":"86113a37","536":"9a937719","552":"ccaccccd","854":"102e98f7","911":"985cc039","963":"b879116b"}[chunkId] + ".chunk.js";
};